export enum ExternalCalendarDateRangeCommon {
  FROM = 'From',
  TO = 'To',
}
